<template>
    <Card :header="$t('currentListOfOffers')">
        <DataTable
            :header="$t('displayedOnYourWebsite')"
            :items="fetchDataIn"
            :fields="fields"
            :pagination="false"
        >
            <template #cell(price)="{item}">
                <div class="nowrap">
                    {{ $format.currency(item.price) }}
                </div>
            </template>
        </DataTable>
        <DataTable
            :header="$t('notDisplayedOnYourWebsite')"
            :items="fetchDataNotIn"
            :fields="fields"
            :pagination="false"
        >
            <template #cell(price)="{item}">
                <div class="nowrap">
                    {{ $format.currency(item.price) }}
                </div>
            </template>
        </DataTable>
    </Card>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'OfferList',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.$req('producerProduct/offers'),
            };
        },
        computed: {
            item() {
                return this.parentComponent.item;
            },
            fields() {
                return [
                    {
                        key: 'id',
                        label: this.$t('id'),
                        sortable: true,
                    },
                    {
                        key: 'name',
                        label: this.$t('name'),
                        sortable: true,
                    },
                    {
                        key: 'campaign',
                        label: this.$t('campaign'),
                        sortable: true,
                    },
                    {
                        key: 'price',
                        label: this.$t('price'),
                        sortable: true,
                    },
                    // {
                    //     key: 'action',
                    //     label: '',
                    //     tdClass: 'text-right',
                    //     thClass: 'text-right',
                    // },
                ];
            },
            data() {
                return this.request.getData() || [];
            },
        },
        methods: {
            fetchDataIn() {
                return this.request.get({ urlParams: { id: this.item.id }, requestParams: { pluginOffers: 'in' } });
            },
            fetchDataNotIn() {
                return this.request.get({ urlParams: { id: this.item.id }, requestParams: { pluginOffers: 'notIn' } });
            },
        },
    };
</script>



<style lang="scss" scoped></style>
